// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weight-loss-chart {
  margin-top: 12px;
}

.weight-loss-chart .chart-title {
  font-size: 22px;
  font-weight: 700;
  line-height: 28px;
  color: var(--orange);
  text-align: center;
  margin-bottom: 12px;
}

.weight-loss-chart .goal {
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 10px 0;
  border-radius: 12px;
  background-color: var(--light-gray);
}

.weight-loss-chart .goal span {
  text-align: center;
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
}

.weight-loss-chart .goal span span {
  font-weight: 700;
}


.weight-loss-chart .date {
  padding: 4px 0;
  margin: 20px auto 0;
  max-width: 250px;
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 12px;
  background-color: var(--dark-gray);
}

.weight-loss-chart .date span {
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
  color: white;
}

.weight-loss-chart svg {
  width: 100%;
  max-width: 327px;
  margin: 0 auto;
}

.weight-loss-chart svg .current-weight,
.weight-loss-chart svg .intermediate-weight,
.weight-loss-chart svg .goal-weight {
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  fill: var(--dark-gray);
}

.weight-loss-chart svg .goal-weight tspan {
  font-size: 13px;
  font-weight: 700;
  fill: white;
}

.weight-loss-chart .timeline {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  margin: 12px auto 24px;

  font-size: 11px;
  font-weight: 700;
  line-height: 11px;
}

.weight-loss-chart .timeline .end {
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.weight-loss-chart.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,eAAe;EACf,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;;EAEtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".weight-loss-chart {\n  margin-top: 12px;\n}\n\n.weight-loss-chart .chart-title {\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 28px;\n  color: var(--orange);\n  text-align: center;\n  margin-bottom: 12px;\n}\n\n.weight-loss-chart .goal {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  padding: 10px 0;\n  border-radius: 12px;\n  background-color: var(--light-gray);\n}\n\n.weight-loss-chart .goal span {\n  text-align: center;\n  font-size: 17px;\n  font-weight: 400;\n  line-height: 22px;\n}\n\n.weight-loss-chart .goal span span {\n  font-weight: 700;\n}\n\n\n.weight-loss-chart .date {\n  padding: 4px 0;\n  margin: 20px auto 0;\n  max-width: 250px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  border-radius: 12px;\n  background-color: var(--dark-gray);\n}\n\n.weight-loss-chart .date span {\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 18px;\n  color: white;\n}\n\n.weight-loss-chart svg {\n  width: 100%;\n  max-width: 327px;\n  margin: 0 auto;\n}\n\n.weight-loss-chart svg .current-weight,\n.weight-loss-chart svg .intermediate-weight,\n.weight-loss-chart svg .goal-weight {\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 16px;\n  fill: var(--dark-gray);\n}\n\n.weight-loss-chart svg .goal-weight tspan {\n  font-size: 13px;\n  font-weight: 700;\n  fill: white;\n}\n\n.weight-loss-chart .timeline {\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  align-items: center;\n  margin: 12px auto 24px;\n\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 11px;\n}\n\n.weight-loss-chart .timeline .end {\n  text-align: right;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
